/**
 *  Kundenerklärung Photovoltaik, siehe snippets/pv-erklaerung.liquid
 */
if (!customElements.get('pv-erklaerung')) {
  class PvErklaerung extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.button = this.parentNode.querySelector('.button.checkout-button');
      if (!this.checkbox || !this.button) return;
      this.form = this.button.form;
      this.pruefen();
      this.checkbox.addEventListener('change', () => {
        this.pruefen();
        this.speichern = fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'PV-Erklaerung': this.checkbox.checked ? 'bestätigt' : '' } })
        }).catch(() => {});
      });
      this.button.addEventListener('click', (e) => {
        if (!this.checkbox.checked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.checkbox.reportValidity();
          this.checkbox.focus();
        }
      });
    }
    pruefen() {
      this.checkbox.setCustomValidity(this.checkbox.checked ? '' : 'Bitte bestätige die Erklärung zur Photovoltaikanlage.');
      // Zusätzlich als verstecktes Feld im Kassen-Formular, damit der Wert
      // auch dann mitgeht, wenn die Speicherung im Hintergrund noch läuft
      if (!this.form) return;
      let feld = this.form.querySelector('input[name="attributes[PV-Erklaerung]"]');
      if (!feld) {
        feld = document.createElement('input');
        feld.type = 'hidden';
        feld.name = 'attributes[PV-Erklaerung]';
        this.form.appendChild(feld);
      }
      feld.value = this.checkbox.checked ? 'bestätigt' : '';
    }
  }
  customElements.define('pv-erklaerung', PvErklaerung);
}
